"use client"

interface ChatBubbleProps {
    isOpen: boolean
    onClick: () => void
    primaryColor?: string
    unreadCount?: number
    position?: "bottom-right" | "bottom-left" | "top-right" | "top-left"
}

export function ChatBubble({ isOpen, onClick, primaryColor = "#3b82f6", unreadCount = 0, position = "bottom-right" }: ChatBubbleProps) {
    const adjustColor = (color: string, percent: number): string => {
        const num = parseInt(color.replace("#", ""), 16)
        const amt = Math.round(2.55 * percent)
        const R = (num >> 16) + amt
        const G = (num >> 8 & 0x00FF) + amt
        const B = (num & 0x0000FF) + amt
        return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
            (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
            (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
    }

    return (
        <button
            onClick={onClick}
            style={{
                position: 'fixed',
                bottom: position.includes('bottom') ? '20px' : 'auto',
                top: position.includes('top') ? '20px' : 'auto',
                right: position.includes('right') ? '20px' : 'auto',
                left: position.includes('left') ? '20px' : 'auto',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: primaryColor,
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
                transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = adjustColor(primaryColor, -10)
                e.currentTarget.style.transform = 'scale(1.05)'
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = primaryColor
                e.currentTarget.style.transform = 'scale(1)'
            }}
            aria-label="Open chat"
        >
            {unreadCount > 0 && (
                <span style={{
                    position: 'absolute',
                    top: '-2px',
                    right: '-2px',
                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                    color: 'white',
                    borderRadius: '50%',
                    minWidth: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: '600',
                    padding: '0 4px',
                    border: '2px solid white'
                }}>
                    {unreadCount > 9 ? "9+" : unreadCount}
                </span>
            )}

            <svg 
                width="24" 
                height="24" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2.5}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
            </svg>
        </button>
    )
}